<div class="small" data-test="publication-date-market-report">{{marketReport.publicationDate.toJSDate() | date}}</div>
<a [routerLink]="['/marketReports']" fragment="{{marketReport.id}}" data-test="link-to-market-report">{{marketReport.excerpt}}</a>
